import React, { Component } from 'react';
import '../styles/awards.scss';


class Awards extends Component {
  getData() {
    //console.log("Awards", this.props.items)
    //make an array of the awards
    return this.props.items.map(item => (
        <li key={`${item.awardId}-award`}>
          <div className="flex-row">
              <span className="year">
                <span className="text">
                  {item.year}
                </span>
              </span>
              <span className="title"><a className="base-link link" href={item.url}>{item.title}</a></span>
              <span className="stacks">
                <span className="org">{item.organization}</span>
                <span className="award">{item.award}</span>
              </span>
          </div>
        </li>
      )
    )
  }

  render() {
    return (
      <div className="awards">
        <section id="awards">
          <h1 className="title">Awards</h1>
          <ul>
            {this.getData()}
          </ul>
        </section>
      </div>
    );
  }
}

export default Awards;
